import { useEffect } from 'react';

// Public HTML supplies the initial preview. Update the same elements on navigation
// without a legacy lifecycle or duplicate tags in React StrictMode.
export default function PageMetadata({ language, title, description, url }) {
  useEffect(() => {
    document.documentElement.lang = language;
    document.title = title;
    const upsert = (selector, tag, attributes) => {
      let element = document.head.querySelector(selector);
      if (!element) { element = document.createElement(tag); document.head.appendChild(element); }
      Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
    };
    const nameMeta = (name, content) => upsert('meta[name="' + name + '"]', 'meta', { name, content });
    const propertyMeta = (property, content) => upsert('meta[property="' + property + '"]', 'meta', { property, content });
    nameMeta('description', description);
    nameMeta('theme-color', '#174c3c');
    propertyMeta('og:type', 'website');
    propertyMeta('og:site_name', 'Plannely');
    propertyMeta('og:title', title);
    propertyMeta('og:description', description);
    propertyMeta('og:url', url);
    propertyMeta('og:image', 'https://plannely.app/logo512.png?v=20261013');
    nameMeta('twitter:card', 'summary');
    nameMeta('twitter:title', title);
    nameMeta('twitter:description', description);
    nameMeta('twitter:image', 'https://plannely.app/logo512.png?v=20261013');
    upsert('link[rel="canonical"]', 'link', { rel: 'canonical', href: url });
  }, [language, title, description, url]);
  return null;
}
